module.exports = __webpack_public_path__ + "static/media/avocado.11ee975e.png";